import { makeStyles } from '@material-ui/core/styles';

export const useTranscriptStyles = makeStyles(theme => ({
  paper: {
    '&&': {
      top: 52,
      height: 'calc(100% - 52px)',
      width: 400,
      maxWidth: '100%',
      background: 'var(--ds-color-white)',
      color: 'var(--ds-color-neutral-900)',
      borderLeft: '1px solid var(--ds-color-neutral-200)',
      boxShadow: theme.shadows[4],
      [theme.breakpoints.down('sm')]: { width: '100%', top: 0, height: '100%' },
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
  },
  close: {
    width: 40,
    height: 40,
    marginRight: theme.spacing(-1.5),
    color: 'var(--ds-color-neutral-600)',
    '& svg': { fontSize: 16 },
  },
  meta: {
    padding: theme.spacing(0, 3, 2),
    borderBottom: '1px solid var(--ds-color-neutral-200)',
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  applicantLink: {
    ...theme.typography.body2,
    flexShrink: 0,
    color: 'var(--ds-color-primary)',
    marginRight: theme.spacing(-1),
  },
  mutedName: { color: 'var(--ds-color-neutral-600)' },
  metadata: {
    marginTop: theme.spacing(0.5),
    color: 'var(--ds-color-neutral-600)',
    overflowWrap: 'anywhere',
  },
  body: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(2, 3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  turn: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: theme.spacing(1.5),
  },
  highlighted: {
    margin: theme.spacing(0, -1.5),
    padding: theme.spacing(1.5),
    borderRadius: 12,
    background: 'var(--ds-color-neutral-50)',
    boxShadow: 'inset 2px 0 0 var(--ds-color-primary)',
  },
  message: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    maxWidth: 296,
  },
  cai: {
    alignSelf: 'flex-end',
    alignItems: 'flex-end',
    '& $bubble': { background: 'var(--ds-color-brand-50)' },
  },
  sender: {
    ...theme.typography.overline,
    textTransform: 'none',
    color: 'var(--ds-color-neutral-600)',
  },
  bubble: {
    ...theme.typography.body2,
    color: 'var(--ds-color-neutral-900)',
    lineHeight: `${theme.spacing(2.5)}px`,
    padding: theme.spacing(1, 1.5),
    borderRadius: 12,
    background: 'var(--ds-color-neutral-100)',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap',
  },
  marker: {
    ...theme.typography.overline,
    textTransform: 'none',
    textAlign: 'center',
    color: 'var(--ds-color-neutral-600)',
  },
  feedback: { alignSelf: 'flex-end', marginTop: theme.spacing(-1.5) },
  state: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(3, 4),
    textAlign: 'center',
    borderTop: '1px solid var(--ds-color-neutral-200)',
  },
  error: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    background: 'var(--ds-color-rose-50)',
    borderRadius: theme.misc.borderRadius,
    '& svg': { color: 'var(--ds-color-danger)' },
  },
  footer: {
    padding: theme.spacing(2, 3, 3),
    borderTop: '1px solid var(--ds-color-neutral-200)',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
